import { Component, Input, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';

@Component({
  selector: 'app-order-type-selection',
  templateUrl: './order-type-selection.component.html',
  styleUrls: ['./order-type-selection.component.scss'],
})
export class OrderTypeSelectionComponent implements OnInit {


  ngOnInit() {}

  @Input() selectedType: 'Pickup' | 'Delivery';

  constructor(private popoverController: PopoverController) {}

  selectType(type: 'Pickup' | 'Delivery') {
    this.popoverController.dismiss(type);
  }

}
